import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import auth from "../../services/authService";
import Joi from "joi-browser";
import UploadDocument from "../../comman/UploadDocument";
import { getTotalHours } from "../../services/appService";
import { getAlert } from "../../services/appAlerts";
import { uploadFileToBlob } from "../../services/blobUploadService";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import { updateCandidateAdpDeduction, uploadCandidatePayDocument } from "../../app/store/candidate";
import useForm from "../../app/hooks/useForm";

const schema = {
  adjustmentMinues: Joi.string().required().label("Amount Deducted ($)"),
  notes: Joi.string().required().label("Notes"),
};

function InvoiceApd(props) {
  const {
    selectedObj,
    invType,
    entType,
    timeLogInvoices,
    candidateObj,
    getInvoiceAmount,
    workItem: workflowTask,
    invAdpShowHide,
    handleAdpShowHide,
  } = props;

  const [documents, setDocuments] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const dispatch = useDispatch();

  const doSubmit = async () => {
    if (isProcessing) return;
    setIsProcessing(true);
    const user = auth.getCurrentUser();
    const payload = { ...stateData };
    try {
      let docId = 0;
      if (documents.length > 0 && workflowTask !== undefined) {
        const frmData = new FormData();
        frmData.append("message", payload.notes);
        frmData.append("workflowTask", JSON.stringify(workflowTask));
        frmData.append("userId", user.id);
        frmData.append("files", JSON.stringify(documents.map((file) => {
          return {
            name: file.name,
            type: file.type,
            size: file.size
          }
        })));
        const result = await dispatch(uploadCandidatePayDocument(frmData));
        docId = result?.uploadId;
        if (docId > 0) {
          await Promise.all(
            documents.map((file, key) => {
              if (!file.file) return Promise.resolve();
              return uploadFileToBlob(
                file.file,
                result.sasUrls[key].uploadUrl,
                (progress) => {
                  console.log(`Upload progress for ${file.name}: ${progress}%`);
                }
              );
            })
          );
        }
      }
      payload.docId = docId;
      await dispatch(updateCandidateAdpDeduction(payload));
      handleAdpShowHide("save");
      getAlert("Saved Successfully", "", "success");
    } finally {
      setIsProcessing(false);
    }
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    setStateErrors,
    handleChange: handleFormChange,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    if (selectedObj !== undefined && selectedObj !== "") {
      const nextData = {};
      nextData["notes"] = "";
      nextData["adjustmentMinues"] = "";

      let candidateRate = 0;
      let invoType = invType;
      if (invType === "subcontractor") {
        if (entType === "C2C Basis" && candidateObj?.rates?.subcontractorRate) {
          candidateRate = candidateObj.rates.subcontractorRate;
        }
        else {
          if (candidateObj?.rates?.candidateRate)
            candidateRate = candidateObj.rates.candidateRate;

          invoType = "candidate"
        }
      }

      if (invType === "recruiter" && candidateObj.rates?.recruiterRate)
        candidateRate = candidateObj.rates.recruiterRate;
      if (invType === "agency" && candidateObj.rates?.agencyRate)
        candidateRate = candidateObj.rates.agencyRate;

      let fAmt = 0;
      if (invType === "subcontractor") {
        fAmt = parseFloat(getInvoiceAmount(selectedObj));
      } else {
        fAmt = parseFloat(getTotalHours(selectedObj?.workingHrs) * candidateRate);
      }
      let invAmt = fAmt;
      let baselineAmt = fAmt;
      const invItems = timeLogInvoices.filter((x) => x.timeLogId === selectedObj.id);

      if (invItems.length > 0) {
        const selectedInvoice = invItems[0];
        if (selectedInvoice?.adjustmentMinues > 0) {
          fAmt -= selectedInvoice.adjustmentMinues;
          baselineAmt -= selectedInvoice.adjustmentMinues;
        }
        if (selectedInvoice?.adjustmentPlus > 0) {
          fAmt += selectedInvoice.adjustmentPlus;
          baselineAmt += selectedInvoice.adjustmentPlus;
        }
        if (selectedInvoice?.adpDeduction > 0)
          fAmt -= selectedInvoice.adpDeduction;

        nextData["notes"] = selectedInvoice.adpNotes;
        nextData["adjustmentMinues"] = selectedInvoice.adpDeduction?.toString() ?? "";
      }
      fAmt = parseFloat(fAmt).toFixed(2);
      nextData["id"] = selectedObj.id;
      nextData["finalAmt"] = fAmt;
      nextData["docUploadType"] = invoType;
      nextData["invAmount"] = invAmt;
      nextData["baselineAmt"] = baselineAmt;
      setStateData(nextData);
      setDocuments([]);
      setStateErrors({});
    } else {
      setStateData({});
      setDocuments([]);
      setStateErrors({});
    }
  }, [selectedObj, invType, entType, timeLogInvoices, candidateObj, getInvoiceAmount, setStateData, setStateErrors]);

  const handleChange = ({ currentTarget: input }) => {
    handleFormChange({ currentTarget: input });
    if (input.name === "adjustmentMinues") {
      setStateData((currentData) => {
        const nextData = { ...currentData, [input.name]: input.value };
        const baseline = parseFloat(nextData.baselineAmt) || 0;
        const deduction = parseFloat(input.value) || 0;
        nextData["finalAmt"] = parseFloat(baseline - deduction).toFixed(2);
        return nextData;
      });
    }
  };

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      const doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const index = documents.indexOf(item);
    if (index !== -1) {
      const nextDocuments = [...documents];
      nextDocuments.splice(index, 1);
      setDocuments(nextDocuments);
    }
  };

  const renderInput = (name, label, type = "text") => (
    <Input
      type={type}
      name={name}
      value={stateData[name] || ""}
      label={label}
      onChange={handleChange}
      error={stateErrors[name]}
      req={schema[name]}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={stateData[name] || ""}
      label={label}
      onChange={handleChange}
      error={stateErrors[name]}
      req={schema[name]}
    />
  );

  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
          /* Ensure the modal and backdrop are on top of other elements */
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }

          /* Glassmorphic backdrop filter and blur */
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }

          /* Spring-like transition for scale-in animation */
          .modal.fade .wf-apd-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .wf-apd-modal.modal-dialog {
            transform: scale(1) !important;
          }

          .wf-apd-modal {
            --task-accent: #2563eb; /* Primary Blue */
            --task-soft: #f8fafc;
            max-width: 650px !important;
            width: 100% !important;
          }

          .wf-apd-modal .modal-content {
            border-radius: 16px !important;
            border: none !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
          }

          .wf-apd-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 22px 28px 18px 32px !important;
            background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
            border-bottom: 1px solid #edf2f7 !important;
            overflow: hidden !important;
          }

          .wf-apd-modal .modal-header::before {
            content: "" !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            bottom: 0 !important;
            width: 4px !important;
            background: var(--task-accent) !important;
          }

          .wf-apd-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 12px !important;
            width: 100% !important;
          }

          .wf-apd-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 18px !important;
            width: 100% !important;
          }

          .wf-apd-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }

          .wf-apd-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
            padding-top: 2px !important;
          }

          .wf-apd-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #0f172a !important;
            font-size: 18px !important;
            font-weight: 850 !important;
            line-height: 1.2 !important;
            min-width: 0 !important;
          }

          .wf-apd-modal .rt-header-icon {
            width: 48px !important;
            height: 48px !important;
            min-height: 48px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: var(--task-accent) !important;
            background: #ffffff !important;
            border: 1px solid var(--task-accent) !important;
            box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }

          .wf-apd-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 10px !important;
            min-width: 0 !important;
            flex-wrap: wrap !important;
          }

          .wf-apd-modal .rt-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 4px 10px !important;
            border-radius: 999px !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.02em !important;
            background: #eff6ff !important;
            color: var(--task-accent) !important;
            border: 1px solid rgba(37, 99, 235, 0.1) !important;
          }

          .wf-apd-modal .rt-modal-desc {
            display: inline-flex !important;
            align-items: center !important;
            gap: 6px !important;
            color: #64748b !important;
            font-weight: 500 !important;
            line-height: 1.4 !important;
            font-size: 12px !important;
          }
          .wf-apd-modal .rt-modal-desc i {
            color: var(--task-accent) !important;
          }

          .wf-apd-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 36px !important;
            height: 36px !important;
            padding: 0 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
            outline: none !important;
          }
          .wf-apd-modal .rt-action-btn:hover {
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
          }
          .wf-apd-modal .rt-action-btn i {
            font-size: 11px !important;
            color: #94a3b8 !important;
          }
          .wf-apd-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }

          .wf-apd-modal .modal-body {
            padding: 28px !important;
            background: #ffffff !important;
          }

          .wf-apd-modal .form-group {
            margin-bottom: 20px !important;
          }

          .wf-apd-modal label {
            display: block !important;
            font-size: 12.5px !important;
            font-weight: 800 !important;
            color: #1e3a8a !important;
            margin-bottom: 8px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.05em !important;
          }

          .wf-apd-modal .form-control {
            background: #ffffff !important;
            border: 1.5px solid #cbd5e1 !important;
            border-radius: 10px !important;
            padding: 10px 14px !important;
            font-size: 14px !important;
            font-weight: 600 !important;
            color: #1e293b !important;
            transition: all 0.2s ease !important;
            box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
            outline: none !important;
          }

          .wf-apd-modal .form-control:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          }

          .wf-apd-modal textarea.form-control {
            min-height: 80px !important;
            resize: vertical !important;
          }

          /* Deducted Amount Accent Highlight */
          .wf-apd-modal input[name="adjustmentMinues"] {
            padding-left: 36px !important;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: 12px center !important;
            background-size: 16px 16px !important;
          }

          .wf-apd-modal .wf-final-amount-value-card {
            height: 44px !important;
            display: flex !important;
            align-items: center !important;
            padding: 10px 14px 10px 36px !important;
            font-size: 14px !important;
            font-weight: 700 !important;
            border-radius: 10px !important;
            outline: none !important;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2315803d'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V19h-2.82v-.91c-1.39-.33-2.58-1.22-2.83-2.59h1.79c.21.64.76 1.09 1.48 1.15V13.8c-1.63-.44-2.82-1.32-2.82-3.1 0-1.61 1.09-2.68 2.38-2.97V7h2.82v.91c1.24.26 2.11 1.02 2.37 2.13h-1.8c-.18-.54-.62-.9-1.23-.96v2.79c1.69.49 2.82 1.34 2.82 3.19 0 1.64-1.07 2.76-2.4 3.03z'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: 12px center !important;
            background-size: 16px 16px !important;
            background-color: #f0fdf4 !important;
            border: 1.5px solid #bbf7d0 !important;
            color: #15803d !important;
            box-shadow: inset 0 2px 4px rgba(15, 23, 42, 0.02) !important;
          }

          .wf-apd-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
            gap: 12px !important;
          }

          .wf-apd-modal .wf-modal-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            padding: 9px 20px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            outline: none !important;
          }
          .wf-apd-modal .wf-modal-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
          }

          .wf-apd-modal .wf-btn-save {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            height: 38px !important;
            padding: 0 24px !important;
            border-radius: 8px !important;
            border: 1px solid rgba(37, 99, 235, 0.15) !important;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
            color: #ffffff !important;
            font-size: 13.5px !important;
            font-weight: 700 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            outline: none !important;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15) !important;
          }
          .wf-apd-modal .wf-btn-save:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2) !important;
          }
          .wf-apd-modal .wf-btn-save:active {
            transform: scale(0.97) !important;
          }
        `}} />
      <Modal show={invAdpShowHide} size="xl" dialogClassName="wf-apd-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-calculator" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>ADP Deduction</span>
                      <span className="rt-modal-title-badge">Adjustments</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Manage and record ADP deduction amounts and notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleAdpShowHide("", "")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            <div className="col-md-6">
              {renderInput("adjustmentMinues", "Amount Deducted ($)")}
            </div>
            <div className="col-md-6 form-group">
              <label className="form-control-label">Amount After Deduction</label>
              <div className="wf-final-amount-value-card">
                {stateData.finalAmt || "0.00"}
              </div>
            </div>
            <div className="col-md-12">
              {renderTextArea("notes", "Notes")}
            </div>
            <div className="col-md-12">
              <UploadDocument
                documents={documents}
                onFileChange={onFileChange}
                handleFileRemove={handleFileRemove}
              ></UploadDocument>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleAdpShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-save"
            onClick={handleSubmit}
            disabled={isProcessing}
          >
            <i className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-check"}`} aria-hidden="true"></i>{" "}
            {isProcessing ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default InvoiceApd;
